/**
 * The type of UI controll.
 */
export enum ControlType {
    JOYSTICK='joy',
    BUTTON='btn',
}